/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Filter_ActiveInputs */

const en_editor_filter_active = /** @type {(inputs: Editor_Filter_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter active`)
};

const fr_editor_filter_active = /** @type {(inputs: Editor_Filter_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtre actif`)
};

const de_editor_filter_active = /** @type {(inputs: Editor_Filter_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter aktiv`)
};

const it_editor_filter_active = /** @type {(inputs: Editor_Filter_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtro attivo`)
};

const ru_editor_filter_active = /** @type {(inputs: Editor_Filter_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фильтр активен`)
};

const es_editor_filter_active = /** @type {(inputs: Editor_Filter_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtro activo`)
};

const zh_cn2_editor_filter_active = /** @type {(inputs: Editor_Filter_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`过滤器已激活`)
};

const ja_editor_filter_active = /** @type {(inputs: Editor_Filter_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フィルターが有効`)
};

const hi_editor_filter_active = /** @type {(inputs: Editor_Filter_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़िल्टर सक्रिय`)
};

const pt_pt2_editor_filter_active = /** @type {(inputs: Editor_Filter_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtro ativo`)
};

/**
* | output |
* | --- |
* | "Filter active" |
*
* @param {Editor_Filter_ActiveInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_filter_active = /** @type {((inputs?: Editor_Filter_ActiveInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Filter_ActiveInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_editor_filter_active(inputs)
	if (locale === "de") return de_editor_filter_active(inputs)
	if (locale === "it") return it_editor_filter_active(inputs)
	if (locale === "ru") return ru_editor_filter_active(inputs)
	if (locale === "es") return es_editor_filter_active(inputs)
	if (locale === "zh-CN") return zh_cn2_editor_filter_active(inputs)
	if (locale === "ja") return ja_editor_filter_active(inputs)
	if (locale === "hi") return hi_editor_filter_active(inputs)
	if (locale === "pt-PT") return pt_pt2_editor_filter_active(inputs)
	return en_editor_filter_active(inputs)
});